export enum EmailTypeEnum {
  'accepted' = 'accepted',
  'refused' = 'refused',
  'invitationLive' = 'live_invitation',
  'invitation' = 'invitation',
  'other' = 'other',
}
